export default {
  items: [
    {
      name: "Dashboard",
      url: "/globalview",
      icon: "icon-grid"
      // badge: {
      //   variant: 'primary',
      //   text: 'NEW'
      // }
    },
    {
      title: true,
      name: "Training",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Indoor cycling",
      url: "/indoor_cycling",
      class: "cycling menuIcon"
    },
    {
      name: "Treadmill",
      url: "/treadmill",
      class: "treadmill menuIcon"
    },
    {
      name: 'Elliptical',
      url: '/elliptical',
      class: 'elliptical menuIcon'
    },
    {
      title: true,
      name: "Personal ",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Settings",
      url: "/profile",
      icon: "icon-options"
    },
    {
      name: "Strava",
      url: "/strava",
      icon: "icon-link",
    
    },
    {
      name: "Trainingym",
      url: "/trainingym",
      icon: "icon-link",
    
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js